var _defs, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgKanzleiLogo = function SvgKanzleiLogo(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "kanzlei-logo_svg__Ebene_1",
    "data-name": "Ebene 1",
    viewBox: "0 0 172.15 24.63",
    ref: ref
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "kanzlei-logo_svg__clippath"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24.47v24.63H0z",
    className: "kanzlei-logo_svg__cls-1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "kanzlei-logo_svg__clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24.47v24.63H0z",
    className: "kanzlei-logo_svg__cls-1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "kanzlei-logo_svg__clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24.47v24.63H0z",
    className: "kanzlei-logo_svg__cls-1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "kanzlei-logo_svg__clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24.47v24.63H0z",
    className: "kanzlei-logo_svg__cls-1"
  })), /*#__PURE__*/React.createElement("style", null, ".kanzlei-logo_svg__cls-1,.kanzlei-logo_svg__cls-5{fill:none}.kanzlei-logo_svg__cls-5{isolation:isolate}.kanzlei-logo_svg__cls-8{fill:#023e84}"))), /*#__PURE__*/React.createElement("g", {
    id: "kanzlei-logo_svg__Gruppe_2950",
    "data-name": "Gruppe 2950"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kanzlei-logo_svg__logo-wiso-meinbuero-rgb"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kanzlei-logo_svg__Gruppe_2939",
    "data-name": "Gruppe 2939"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      clipPath: "url(#kanzlei-logo_svg__clippath)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kanzlei-logo_svg__Gruppe_2935",
    "data-name": "Gruppe 2935"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kanzlei-logo_svg__Pfad_25",
    d: "M24.63 10.39V.16c0-.09-.06-.16-.15-.16H14.23c-.09 0-.16.06-.16.15v2.49c0 .1.07.18.16.2 3.83.74 6.82 3.73 7.56 7.56.02.09.1.16.2.16h2.47c.09 0 .16-.08.16-.16",
    className: "kanzlei-logo_svg__cls-8",
    "data-name": "Pfad 25"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      clipPath: "url(#kanzlei-logo_svg__clippath-1)"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "kanzlei-logo_svg__Gruppe_2936",
    "data-name": "Gruppe 2936"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kanzlei-logo_svg__Pfad_26",
    d: "M10.56 10.39V.16c0-.09-.06-.16-.15-.16H7.92c-.1 0-.18.07-.2.16C7.33 3.65 3.95 7.04.16 7.73c-.09.02-.16.1-.16.2v2.47c0 .09.06.16.15.16H10.4c.09 0 .16-.06.16-.15z",
    className: "kanzlei-logo_svg__cls-8",
    "data-name": "Pfad 26"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      clipPath: "url(#kanzlei-logo_svg__clippath-2)"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "kanzlei-logo_svg__Gruppe_maskieren_2937",
    "data-name": "Gruppe maskieren 2937"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kanzlei-logo_svg__Pfad_27",
    d: "M10.56 24.47V22c0-.1-.07-.18-.16-.2-3.49-.43-6.87-3.78-7.56-7.56a.204.204 0 0 0-.2-.16H.17c-.09 0-.16.06-.16.15v.02H0v10.23c0 .09.06.16.15.16H10.4c.09 0 .16-.06.16-.15z",
    className: "kanzlei-logo_svg__cls-8",
    "data-name": "Pfad 27"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      clipPath: "url(#kanzlei-logo_svg__clippath-3)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "kanzlei-logo_svg__Gruppe_2938",
    "data-name": "Gruppe 2938"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kanzlei-logo_svg__Pfad_28",
    d: "M24.63 16.71v-2.47c0-.09-.06-.16-.15-.16H14.23c-.09 0-.16.06-.16.15v10.25c0 .09.06.16.15.16h2.49c.1 0 .18-.07.2-.16a9.54 9.54 0 0 1 7.56-7.56c.1-.01.17-.1.16-.2",
    "data-name": "Pfad 28",
    style: {
      fill: "#fa7d19"
    }
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "kanzlei-logo_svg__MeinB\\xFCro_Kanzlei",
    className: "kanzlei-logo_svg__cls-5",
    "data-name": "MeinB\\xFCro Kanzlei"
  }, /*#__PURE__*/React.createElement("g", {
    className: "kanzlei-logo_svg__cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.21 5.7v13.07h-1.82V7.68h-.28l-3.4 10.58h-1.94L34.35 7.68h-.27v11.1h-1.82V5.7h3.19l3.29 10.66L42.01 5.7h3.21ZM48.48 17.85c-.62-.75-.93-1.95-.93-3.58 0-1.76.33-3.07 1-3.92s1.69-1.28 3.09-1.28c2.58 0 3.88 1.47 3.88 4.41l-.11 1.29h-6.06q.015 1.02.27 1.59c.16.37.43.64.8.81s.89.25 1.56.25c.39 0 .84 0 1.33-.03.49-.02.94-.05 1.33-.09l.53-.06.04 1.37c-1.48.25-2.68.38-3.59.38-1.46 0-2.5-.38-3.12-1.13Zm5.26-4.47c0-1.03-.16-1.75-.48-2.19-.32-.43-.86-.65-1.62-.65-.8 0-1.38.22-1.75.67q-.555.675-.57 2.16h4.43ZM57.62 5.49h1.75v1.92h-1.75zm0 3.78h1.77v9.5h-1.77zM61.99 9.27h1.75v.63c.54-.3 1.04-.52 1.48-.65s.91-.19 1.41-.19c.8 0 1.43.16 1.88.47.46.32.78.81.97 1.47s.29 1.57.29 2.71v5.05H68v-5.02c0-.8-.05-1.42-.14-1.85-.09-.44-.27-.75-.53-.95s-.64-.29-1.13-.29c-.67 0-1.37.15-2.11.44l-.32.15v7.52H62v-9.5ZM72.54 5.7h4.86c1.34 0 2.33.27 2.97.82s.96 1.41.96 2.6c0 .75-.13 1.35-.38 1.8s-.66.82-1.22 1.11c.66.25 1.15.63 1.47 1.12q.48.735.48 1.98c0 2.43-1.37 3.65-4.1 3.65h-5.05V5.7Zm4.86 5.66c.71 0 1.24-.17 1.58-.51s.51-.86.51-1.56-.18-1.21-.53-1.53-.91-.48-1.65-.48h-2.95v4.08zm.11 5.81c.77 0 1.35-.16 1.75-.48.39-.32.59-.85.59-1.6 0-1.44-.8-2.17-2.41-2.17h-3.08v4.24h3.15ZM85.06 18.52c-.44-.31-.75-.8-.93-1.48s-.27-1.61-.27-2.8V9.28h1.77v4.96c0 .87.04 1.53.13 1.97s.26.74.5.92c.25.18.62.27 1.13.27.42 0 .81-.05 1.19-.15.37-.1.78-.25 1.21-.44V9.29h1.77v9.5h-1.77v-.63c-.53.3-1.01.52-1.43.65s-.89.19-1.4.19c-.82 0-1.46-.16-1.9-.47ZM85 5.17h1.71v1.96H85zm3.9 0h1.71v1.96H88.9zM94.18 9.27h1.75v1.2c1.13-.72 2.24-1.19 3.34-1.41v1.79c-.49.1-1.01.24-1.54.42s-.98.35-1.33.51l-.46.21v6.78h-1.77v-9.5ZM101.3 17.8c-.65-.79-.97-2.04-.97-3.73s.33-3 .99-3.8 1.72-1.2 3.17-1.2 2.53.4 3.18 1.21c.65.8.98 2.07.98 3.79s-.32 2.93-.97 3.72c-.65.8-1.71 1.2-3.19 1.2s-2.55-.4-3.19-1.19m4.61-.67c.33-.21.57-.56.71-1.04s.21-1.15.21-2.01-.07-1.6-.22-2.09-.39-.85-.72-1.05-.8-.31-1.4-.31-1.06.1-1.41.31c-.34.21-.59.56-.73 1.06-.15.5-.22 1.19-.22 2.08s.07 1.52.21 2q.21.735.72 1.05c.34.22.82.32 1.42.32s1.08-.11 1.42-.32Z",
    className: "kanzlei-logo_svg__cls-8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "kanzlei-logo_svg__cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m119.47 13.61-1.75.17v5h-2.62V5.85h2.62v5.64l1.77-.17 2.11-5.47h2.98l-2.81 6.46 2.89 6.46h-3.02l-2.17-5.17ZM125.41 15.89c0-.99.26-1.7.79-2.14s1.37-.69 2.54-.77l2.03-.15v-.59c0-.38-.09-.65-.26-.8s-.46-.23-.86-.23-1 .02-1.73.05-1.35.07-1.84.1L126 9.59c1.37-.37 2.66-.55 3.88-.55s2.09.25 2.63.76q.81.765.81 2.43v3.95c.03.32.08.53.16.65.08.11.24.2.47.25l-.08 1.92c-.66 0-1.18-.04-1.57-.13s-.77-.27-1.15-.53c-.92.44-1.86.66-2.79.66-1.96 0-2.95-1.04-2.95-3.12Zm5.07.82.29-.08V14.6l-1.73.15c-.71.06-1.06.44-1.06 1.14s.31 1.04.93 1.04c.48 0 1.01-.08 1.58-.23ZM135.75 9.27h2.53v.53c.48-.28.91-.48 1.28-.59s.78-.17 1.21-.17c1.17 0 2 .37 2.49 1.12s.74 1.9.74 3.46v5.15h-2.55V13.7c0-.87-.1-1.49-.31-1.84s-.61-.53-1.19-.53c-.42 0-.89.09-1.42.27l-.23.08v7.11h-2.55v-9.5ZM145.86 16.49l3.99-4.94h-3.99V9.27h7.05v2.28l-3.99 4.94h3.99v2.28h-7.05zM155 5.47h2.55v13.3H155zM160.43 17.88q-.99-1.125-.99-3.63c0-2.505.34-3.05 1.04-3.91s1.76-1.29 3.22-1.29c1.34 0 2.36.36 3.05 1.07s1.04 1.79 1.04 3.22l-.19 1.77h-5.59c.03.44.1.78.24 1.02s.35.4.65.49.71.14 1.25.14c.42 0 .92-.01 1.5-.04s1.01-.05 1.27-.08l.53-.06.04 1.88c-1.43.35-2.71.53-3.84.53-1.48 0-2.55-.37-3.21-1.12Zm4.84-4.71c0-.76-.12-1.29-.35-1.59s-.65-.45-1.24-.45-1.04.16-1.29.46c-.25.31-.39.83-.4 1.57h3.29ZM169.61 5.49h2.55v2.57h-2.55zm0 3.78h2.55v9.5h-2.55z",
    className: "kanzlei-logo_svg__cls-8"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgKanzleiLogo);
export default ForwardRef;